<template>
  <div style="position: relative;">
    <div class="integral" v-if="!isImproveInfo">
      <div class="integral-content" @click="showPointPopup">
        <div class="integral-left">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/recommend-icon2.png" alt=""/>
        </div>
        <div class="integral-text">
          当前订单预计赠送{{ point }}积分
        </div>
        <div class="integral-right">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt=""/>
        </div>
      </div>
      <div class="perfect-info" @click="editInfo">
        请最晚于<span style="border-bottom: 1px solid #AF936B;color: #AF936B;">下船日前</span>至会员中心<span style="color: #006AB6;">完善信息</span>获取预订积分
      </div>
    </div>
    <div class="integral-perfect" v-else @click="showPointPopup">
      <div class="integral-content">
        <div class="integral-left">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/recommend-icon2.png" alt=""/>
        </div>
        <div class="integral-text">
          当前订单预计赠送{{ point }}积分
        </div>
        <div class="integral-right">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt=""/>
        </div>
      </div>
    </div>
    <div class="point-popup" v-if="isShowPointPopup" @click="showPointPopup" :style="!isImproveInfo ? 'bottom: 38px' : 'bottom: 24px'">
      <div class="point-popup-content">
        积分可<span>兑换限量皇家周边</span>，如定制行李箱、光谱号精美船模、各大视频会员等，还可参与<span>免费船票抽奖</span>~
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    point: {
      default: ''
    },
    isImproveInfo:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      isShowPointPopup:false,
      shipCode:'',
      sailDate:''
    }
  },
  mounted() {
    let query = this.$route.query;
    if(query.shipCode && query.sailDate){
      this.shipCode = query.shipCode
      this.sailDate = query.sailDate
    }
  },
  methods: {
    showPointPopup(){
      this.isShowPointPopup = !this.isShowPointPopup
    },
    editInfo(){
      this.$emit('editInfo')
    }
  },
}
</script>
<style scoped lang="less">
.integral{
  width: 335px;
  height: 60px;
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/recommend.png') no-repeat;
  background-size: 100% 100%;
  margin: 10px auto 0;
  color: #592814;
  font-size: 13px;
  font-weight: 500;
  font-family: PingFangSC, PingFang SC;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.integral-content{
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 2px 60px 0 46px;
  .integral-text{
    width: 170px;
    text-align-last: justify;
  }
}
.integral img{
  width: 100%;
  height: 100%;
  display: block;
}
.integral-left{
  width: 40px;
  height: 35px;
}
.integral-right{
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.perfect-info{
  font-size: 12px;
  color: #AF936B;
}
.integral-perfect{
  width: 335px;
  height: 48px;
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/recommend.png') no-repeat;
  background-size: 100% 100%;
  margin: 10px auto 0;
  gap: 4px;
  color: #592814;
  font-size: 13px;
  font-weight: 500;
  font-family: PingFangSC, PingFang SC;
  display: flex;
  align-items: center;
  justify-content: center;
}
.integral-perfect img{
  width: 100%;
  height: 100%;
}
.point-popup{
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup.png') no-repeat;
  background-size: 100%;
  width: 238px;
  height: 203px;
  position: absolute;
  right: 46px;
}
.point-popup .point-popup-content{
  font-size: 14px;
  padding: 80px 27px 43px;
}
.point-popup .point-popup-content span{
  color: #006AB6;
}
</style>